<template>
  <b-container>
    <template>
      <div class="row">
        <div class="col-md-12">
          <KTCodePreview v-bind:title="'Report & Record'">
            <b-form-group>
              <b-button class="mt-5" type="button" size="sm" variant="light">
                Download Grafik
              </b-button>
            </b-form-group>
            <template v-slot:preview>
              <b-row>
                <b-col md="12" class="mb-2">
                  <export-excel :data="json_data" :fields="json_fields" :name="'Report.xls'">
                    <b-button variant="outline-dark" :disabled="loading" @click="loadDataExport">
                      <b-spinner small class="ml-auto" v-if="loading"></b-spinner>
                      <span v-else class="svg-icon svg-icon-sm svg-icon-dark">
                        <i class="flaticon-download"></i>
                      </span>
                      Export
                    </b-button>
                  </export-excel>
                </b-col>
                <b-col md="12">
                  <b-table
                    head-variant="dark"
                    bordered
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    stacked="lg"
                    show-empty
                    responsive
                    @filtered="onFiltered"
                    :busy="isBusy"
                  >
                    <template #cell(no)="data">
                      {{ (currentPage - 1) * 10 + data.index + 1 }}
                    </template>
                    <template #cell(inspection_result)="data">
                      <span v-html="data.item.inspection_result"></span>
                    </template>
                    <template #cell(date)="data">
                      {{ momentDate(data.item.date) }}
                    </template>
                    <template #table-busy>
                      <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </b-col>
                <b-col md="5">
                  <b-pagination
                    v-model="currentPage"
                    @input="paginate"
                    :total-rows="totalRows"
                    :per-page="10"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </b-col>
                <b-col md="5">
                  <h4 class="float-right">
                    Showing
                    <span v-if="totalPerPage">1-{{ totalPerPage }}</span>
                    <span v-else>0</span>

                    of {{ totalRows }}
                  </h4>
                </b-col>
              </b-row>
            </template>
          </KTCodePreview>
        </div>
      </div>
    </template>
  </b-container>
</template>
<script>
import ApiService from '@/core/services/api.service'
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import * as moment from 'moment'
import 'moment/locale/id'

export default {
  name: 'LastReport',
  props: {
    pabrik: Number,
    plant: Number,
    equipment: Number,
    year: Number,
  },
  data() {
    return {
      sortBy: 'date',
      sort_label: 'DESC',
      items: [],
      fields: [
        { key: 'no', label: 'No', sortable: true },
        { key: 'date', label: 'Tanggal', sortable: true },
        { key: 'nomor_equipment', label: 'Equipment', sortable: true },
        { key: 'nama_part', label: 'Part', sortable: true },
        { key: 'inspection_result', label: 'Hasil', sortable: true },
        { key: 'critically', label: 'Kekritisan', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
      json_fields: {
        No: 'no',
        Tanggal: 'date',
        Equipment: 'nomor_equipment',
        Part: 'nama_part',
        Hasil: 'inspection_result',
        Kekritisan: 'critically',
        Status: 'status',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      totalRows: 0,
      totalPerPage: 0,
      currentPage: 1,
      isBusy: false,
      loading: false,
    }
  },
  components: {
    KTCodePreview,
  },
  created() {
    moment.locale('id')
    var self = this
    self.urlStorage = ApiService.urlStorage()
    ApiService.get(
      '/dashboard/last_report?pabrik=' +
        this.pabrik +
        '&plant=' +
        this.plant +
        '&equipment=' +
        this.equipment +
        '&tahun=' +
        this.year +
        '&sortBy=' +
        this.sortBy +
        '&sortDesc=' +
        this.sort_label
    )
      .then(({ data }) => {
        if (data.status == 'ok') {
          self.items = data.data.data
          self.totalRows = data.data.total
          self.totalPerPage = data.data.data.length
          self.isBusy = false

          self.loadDataExport()
        }
      })
      .catch((response) => {
        console.log(response)
      })
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Data Desain', route: '/datadesain' },
      { title: 'Input Data' },
    ])
  },
  methods: {
    moment: function (date) {
      moment.locale('id')
      return moment(date).format('DD/MM/YYYY')
    },
    momentDate: function (date) {
      moment.locale('id')
      return moment(date, 'YYYY-MM-DD LTS').format('DD MMM YYYY')
    },
    onFiltered() {
      this.loadData()
    },
    paginate() {
      this.loadData()
    },
    async loadData() {
      var self = this
      self.isBusy = true

      await ApiService.get(
        '/dashboard/last_report?pabrik=' +
          this.pabrik +
          '&plant=' +
          this.plant +
          '&equipment=' +
          this.equipment +
          '&tahun=' +
          this.year +
          '&sortBy=' +
          this.sortBy +
          '&sortDesc=' +
          this.sort_label
      )
        .then(({ data }) => {
          self.items = data.data.data
          self.totalRows = data.data.total
          self.totalPerPage = data.data.data.length
          self.isBusy = false

          self.loadDataExport()
        })
        .catch((response) => {
          console.log(response)
        })
    },
    async loadDataExport() {
      var self = this
      self.loading = true

      await this.timeout(100)
      ApiService.get(
        '/dashboard/report_rekomendasi?pabrik=' +
          this.pabrik +
          '&plant=' +
          this.plant +
          '&equipment=' +
          this.equipment +
          '&tahun=' +
          this.year +
          '&sortBy=' +
          this.sortBy +
          '&sortDesc=' +
          this.sort_label
      )
        .then(({ data }) => {
          if (data.status == 'ok') {
            self.json_data.splice(0, self.json_data.length)
            data.data.forEach((row, index) => {
              self.json_data.push({
                no: index + 1,
                date: row.date,
                nomor_equipment: row.nomor_equipment,
                nama_part: row.nama_part,
                inspection_result: row.inspection_result,
                critically: row.critically,
                status: row.status === null || row.status === 'null' ? '-' : row.status,
              })
            })
            self.loading = false
          }
        })
        .catch((response) => {
          console.log(response)
        })
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms)
      })
    },
  },
  watch: {
    pabrik: function () {
      this.loadData()
    },
    plant: function () {
      this.loadData()
    },
    equipment: function () {
      this.loadData()
    },
    year: function () {
      this.loadData()
    },
  },
}
</script>
